(function(jQuery, Drupal) {
  'use strict';

  Drupal.behaviors.nowSiteAlerts = {
    attach: function(context, settings) {
      const siteAlertCookieOffset = function() {
        const $cookieBlock = jQuery('#block-sdcookieconsentblock');
        if ($cookieBlock.length > 0 && $cookieBlock.is(':visible')) {
          var h = $cookieBlock.outerHeight();
          $cookieBlock.parent().css({'margin-bottom': h + 'px'});
        }
      };

      window.eventQueue.addReady(siteAlertCookieOffset, 'site alert');
      window.eventQueue.addResize(siteAlertCookieOffset);
    }
  };
})(jQuery, Drupal);
